var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cms_fullwidth_lane"},[_c('GrcDB',{ref:"GRCDB"}),_c('div',{staticClass:"cms_maincont_lane",domProps:{"innerHTML":_vm._s(_vm.account_data)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }